import _ from 'underscore'
import WValidationMixin from './w-validation-mixin'
import WAutoCompleteMixin from './w-autocomplete-mixin'

/**
 * @mixin
 */
export default {
    mixins: [WAutoCompleteMixin, WValidationMixin],
    props: {
        /**
         * Apply additional validation rules on top of the default ones.
         * The additional rules are: [vm.validationRules.generic.required, vm.validationRules.password.minLength,
         * vm.validationRules.password.maxLength, vm.validationRules.password.mustContainLetter, vm.validationRules.password.mustContainNumber]
         */
        additionalRules: {
            type: Array,
            default: () => []
        },
        /**
         * Custom validation rules to be apply to the field.
         * Note: This replaces all default validationRules. Please use `additionalRules` if you want to keep the defaults.
         */
        customRules: {
            type: Array,
            default: () => []
        },
        /**
         * Allow the user to clear the field through clicking a clear cross icon.
         */
        clearable: {
            type: Boolean,
            default: true
        },
        /**
         * Put the field in an error state.
         */
        error: {
            type: Boolean,
            default: false
        },
        /**
         * Display error message(s) and style the field red.
         */
        errorMessages: {
            type: [String, Array],
            default: () => []
        },
        /**
         * The id of the element
         */
        id: {
            type: String,
            default: undefined
        },
        /**
         * Set the field as required (adds an asterisk next the label).
         * Note: not needed if validationRules.generic.required used for the rules prop.
         */
        required: {
            type: Boolean,
            default: false
        },
        /**
         * Validation rules to be applied to the field.
         */
        rules: {
            type: Array,
            default: () => []
        },
        /**
         * Validate the field on blue (instead of on input).
         */
        validateOnBlur: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        defaultFieldRules () {
            const vm = this
            const requiredRules = vm.required ? [vm.validationRules.generic.required] : []
            return [
                ...requiredRules,
                ...vm.rules
            ]
        },
        fieldRules () {
            const vm = this

            if (!_.isEmpty(vm.customRules)) {
                return vm.customRules
            }

            return [
                ...vm.defaultFieldRules,
                ...vm.additionalRules
            ]
        },
        isClearable () {
            const vm = this
            return !vm.isRequired && vm.clearable
        },
        isRequired () {
            const vm = this
            const ruleNames = _.pluck(vm.rules, 'name')
            return vm.required || _.contains(ruleNames, 'required')
        }
    },
    methods: {
        handleAppendClick () {
            /**
             * Append click event.
             * @type {undefined}
             */
            this.$emit('click:append')
        },
        handleBlur () {
            /**
             * Blur event.
             * @type {undefined}
             */
            this.$emit('blur')
        },
        handleFocus (value) {
            /**
             * Focus event.
             * @type {object}
             */
            this.$emit('focus', value)
        },
        handleInput (value) {
            /**
             * Input event.
             * @type {string}
             */
            this.$emit('input', value)
        },
        handleEnter () {
            /**
             * Enter event.
             * @type {undefined}
             */
            this.$emit('enter')
        },
        handlePrependClick () {
            /**
             * Prepend click event.
             * @type {undefined}
             */
            this.$emit('click:prepend')
        }
    }
}
